import { SendMessagePayload } from '@tsin-core/services/http/communications.service';

/** Load the full conversation thread for an application.
 *  Charger le fil de conversation complet pour une candidature. */
export class LoadCommunicationThread {
  static readonly type = '[Communications] Load Thread';
  constructor(public applicationId: string) {}
}

/** Send an outbound message to the candidate.
 *  Envoyer un message sortant au candidat. */
export class SendCommunicationMessage {
  static readonly type = '[Communications] Send Message';
  constructor(public payload: SendMessagePayload) {}
}

/** Mark a set of messages as read.
 *  Marquer un ensemble de messages comme lus. */
export class MarkCommunicationMessagesRead {
  static readonly type = '[Communications] Mark Read';
  constructor(public messageIds: string[]) {}
}

/** Clear the communications panel state (e.g. when closing the panel).
 *  Effacer l'état du panneau de messagerie (par ex. lors de la fermeture). */
export class ClearCommunicationThread {
  static readonly type = '[Communications] Clear Thread';
}
